import React from "react";
import { CircularProgress } from "@material-ui/core";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";
import useJobShiftEmergencyPlansViewModel from "./useJobShiftEmergencyPlansViewModel";
import useJobShiftEmergencyProceduresViewModel from "./useJobShiftEmergencyProceduresViewModel";

export default function JobShiftEmergencyDocumentOverlay({ open, title, context, onClose, documentType }) {
  const isPlans = documentType === "plans";
  const plansModel = useJobShiftEmergencyPlansViewModel({ open: open && isPlans, context });
  const proceduresModel = useJobShiftEmergencyProceduresViewModel({ open: open && !isPlans, context });
  const model = isPlans ? plansModel : proceduresModel;

  if (!open) return null;

  return (
    <div className={styles.PreviewOverlay}>
      <div className={styles.PreviewModal}>
        <div className={styles.viewPreview}>
          <div className={styles.PreviewPlatformBar}>
            <button className={styles.PreviewPlatformButton} onClick={onClose} type="button">
              <span>Back</span>
            </button>
            <div className="text-muted">{title}</div>
          </div>
          {model.loading || !model.loaded ? (
            <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100% - 54px)" }}>
              <CircularProgress size={30} />
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100% - 54px)" }}>
              <span className="text-muted">{title} document view</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
